<template>
  <div class="pallet_station">
    <div class="pallet_station_head">
      <div><img src="../../assets/logo.svg" /></div>
    </div>
    <div class="mo_right_info">
      <p>All products are directly supplied by <b>ANTDlY</b>,</p>
      <p>
        through which procurement, fulfillment and logistics services are
        completed.
      </p>
    </div>
    <div class="pallet_station_content">
      <div class="pallet_station_content_left">
        <img class="logo" src="../../assets/pallet_logo.png" alt="" />
        <div class="left_intro">
          <div class="left_intro_li">
            <img src="../../assets/pallet_intro_icon1.svg" alt="" />
            <span
              >Purchase the latest popular products from the United States at a
              low price.</span
            >
          </div>
          <div class="left_intro_li">
            <img src="../../assets/pallet_intro_icon2.svg" alt="" />
            <span>All products are stored in our US-based warehouses.</span>
          </div>
          <div class="left_intro_li">
            <img src="../../assets/pallet_intro_icon3.svg" alt="" />
            <span
              >Once a business cooperation is established, we will ship quickly
              within 3 days.</span
            >
          </div>
        </div>
      </div>
      <div class="pallet_station_content_right">
        <div class="right_info">
          <p>
            All products are directly supplied <br />
            by <b>ANTDlY</b>,
          </p>
          <p>
            through which procurement, fulfillment and logistics services are
            completed.
          </p>
        </div>
        <div class="right_form">
          <div>
            <div
              :class="error1 ? 'cs_form_inp cs_form_inp_error' : 'cs_form_inp'"
            >
              <input
                type="text"
                placeholder="Email"
                v-model="form.email"
                @input="write(1)"
              />
            </div>
            <div class="error_code" v-show="errorEmail">{{ errorEmail }}</div>
          </div>
          <div>
            <div class="right_form_li">
              <div
                :class="
                  error2 ? 'cs_form_inp cs_form_inp_error' : 'cs_form_inp'
                "
              >
                <input
                  type="text"
                  placeholder="Verification Code"
                  v-model="form.code"
                  @input="write(2)"
                />
              </div>
              <div class="get_code" @click="getCode" v-if="showCode">
                Get Code
              </div>
              <div class="get_code get_code_disabled" v-else>
                {{ waittime }} Second
              </div>
            </div>
            <div class="error_code" v-show="errorCode">{{ errorCode }}</div>
          </div>
          <div
            :class="
              error3
                ? 'password_inp cs_form_inp cs_form_inp_error'
                : 'password_inp cs_form_inp'
            "
          >
            <input
              :type="passflagType"
              placeholder="Password"
              v-model="form.password"
              @input="write(3)"
            />
            <img
              :src="`/static/imgs/${
                passflag ? 'icon_eye' : 'icon_eye_close'
              }.svg`"
              alt=""
              @click="getFlag()"
            />
          </div>
          <div class="right_form_li right_form_li_country">
            <div class="select_country" @click="selectCountry()">
              <div class="country_code">
                <div :class="`iti-flag ${countryIcon}`"></div>
                <span>+{{ form.countryCode }}</span>
              </div>
              <img
                ref="select_country_icon"
                src="../../assets/pallet_select.svg"
                alt=""
              />
            </div>
            <div
              :class="error4 ? 'cs_form_inp cs_form_inp_error' : 'cs_form_inp'"
            >
              <input
                type="text"
                placeholder="Phone Number"
                v-model="form.telephone"
                @input="write(4)"
              />
            </div>
            <div class="country_list" v-show="showSelect">
              <div class="country_search">
                <input
                  type="text"
                  placeholder="Search"
                  v-model="countrySearch"
                  @input="onSearch"
                />
                <img src="../../assets/icon_search.svg" alt="" />
              </div>
              <div
                class="country_list_li"
                v-for="(item, index) in allCountry"
                :key="index"
                @click="changeCountry(item)"
              >
                <div :class="`iti-flag ${item.iso2}`"></div>
                <span class="dial_code"
                  >{{ item.name }} (+{{ item.dialCode }})</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="right_describe">
          Leave your real contact information and we will help you get greater
          profits!
        </div>
        <div class="right_button" @click="submit">Sign Up for Free</div>
        <div class="go_ad" @click="goAD">Already have an account? Log in</div>
        <div class="left_intro mo_left_intro">
          <div class="left_intro_li">
            <img src="../../assets/pallet_intro_moicon1.svg" alt="" />
            <span
              >Purchase the latest popular products from the United States at a
              low price.</span
            >
          </div>
          <div class="left_intro_li">
            <img src="../../assets/pallet_intro_moicon2.svg" alt="" />
            <span>All products are stored in our US-based warehouses.</span>
          </div>
          <div class="left_intro_li">
            <img src="../../assets/pallet_intro_moicon3.svg" alt="" />
            <span
              >Once a business cooperation is established, we will ship quickly
              within 3 days.</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="pallet_station_foot">
      <div class="foot_title">Our Partnership</div>
      <div class="foot_list">
        <div class="foot_list_li">
          <img src="../../assets/pallet_foot_icon1.svg" alt="" />
        </div>
        <div class="foot_list_li">
          <img src="../../assets/pallet_foot_icon2.svg" alt="" />
        </div>
        <div class="foot_list_li">
          <img src="../../assets/pallet_foot_icon3.svg" alt="" />
        </div>
        <div class="foot_list_li">
          <img src="../../assets/pallet_foot_icon4.svg" alt="" />
        </div>
        <div class="foot_list_li">
          <img src="../../assets/pallet_foot_icon5.svg" alt="" />
        </div>
        <div class="foot_list_li">
          <img src="../../assets/pallet_foot_icon6.svg" alt="" />
        </div>
        <div class="foot_list_li">
          <img src="../../assets/pallet_foot_icon7.svg" alt="" />
        </div>
        <div class="foot_list_li">
          <img src="../../assets/pallet_foot_icon8.svg" alt="" />
        </div>
        <div class="foot_list_li">
          <img src="../../assets/pallet_foot_icon9.svg" alt="" />
        </div>
        <div class="foot_list_li">
          <img src="../../assets/pallet_foot_icon10.svg" alt="" />
        </div>
      </div>
    </div>
    <div class="pallet_station_rights">© ANTDIY All Rights Reserved.</div>
    <div class="successful_dialog" v-if="isSuccessful">
      <div class="successful_dialog_box">
        <div class="dialog_content">
          <img src="../../assets/pallet_successfull.svg" alt="" />
          <div class="dialog_title">
            You have successfully registered ANTDIY!
          </div>
          <div class="dialog_span">
            Our business manager will conduct business communication
            <br class="mo_br" />
            with you within 24 hours.
          </div>
          <div class="dialog_button" @click="goAD">Log in to ANTDIY</div>
          <div class="dialog_foot">
            Automatic jump after <span>{{ skipTime }}</span> seconds
          </div>
        </div>
        <div class="dialog_foot_box">
          <div class="dialog_foot">
            Automatic jump after <span>{{ skipTime }}</span> seconds
          </div>
          <div class="dialog_button" @click="goAD">Log in to ANTDIY</div>
        </div>
      </div>
    </div>
    <div
      class="country_dialog"
      v-show="showSelect"
      @click="showSelect = false"
    ></div>
  </div>
</template>

<script>
import { allCountries } from "../../utils/countryCode.js";
import "../../utils/countryCode.css";
export default {
  name: "palletStation",
  data() {
    return {
      form: {
        email: "",
        code: "",
        password: "",
        telephone: "",
        countryCode: "1",
      },
      countryIcon: "us",
      countrySearch: "",
      error1: false,
      error2: false,
      error3: false,
      error4: false,
      showCode: true,
      waittime: 59,
      isSuccessful: false,
      allCountry: allCountries,
      showSelect: false,
      skipTime: 5,
      timer: undefined,
      errorEmail: "",
      errorCode: "",
      passflag: false,
      passflagType: "password",
    };
  },
  methods: {
    submit() {
      let flag = true;
      let reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
      if (
        !this.form.email.trim() ||
        (this.form.email && !reg.test(this.form.email))
      ) {
        this.error1 = true;
        flag = false;
      }
      if (!this.form.code.trim()) {
        this.error2 = true;
        flag = false;
      }
      if (!this.form.password.trim()) {
        this.error3 = true;
        flag = false;
      }
      if (!this.form.telephone.trim()) {
        this.error4 = true;
        flag = false;
      }
      if (flag) {
        let _this = this;
        let params = {
          mailbox: this.form.email.trim(),
          code: this.form.code.trim(),
          password: this.form.password.trim(),
          phone: "+" + this.form.countryCode + " " + this.form.telephone.trim(),
          source: "tiktokapparelus",
          series_id: 1,
        };
        this.$axios
          .post(
            `https://gateway.antdiy.vip/account-service/user/register`,
            params
          )
          .then((res) => {
            if (res.data.success) {
              this.isSuccessful = true;
              this.count2();
            } else {
              this.errorCode = res.data.msg;
              clearInterval(_this.timer);
            }
          });
      }
    },
    getCode() {
      let _this = this;
      let reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
      if (!reg.test(this.form.email)) {
        this.error1 = true;
        return;
      }
      this.error1 = false;
      this.showCode = false;
      _this.count();
      let params = {
        email: this.form.email,
        type: 1,
        series_id: 1,
      };
      this.$axios
        .post(`https://gateway.antdiy.vip/account-service/email/send`, params)
        .then((res) => {
          if (res.data.success) {
          } else {
            this.errorEmail = res.data.msg;
            this.showCode = true;
            clearInterval(_this.timer);
          }
        });
    },
    getFlag() {
      this.passflag = !this.passflag;
      this.passflagType = this.passflag ? "text" : "password";
    },
    onSearch() {
      this.allCountry = allCountries.filter((item) => {
        return (
          item.name.toLowerCase().includes(this.countrySearch.toLowerCase()) ||
          item.dialCode.toLowerCase().includes(this.countrySearch.toLowerCase())
        );
      });
    },
    selectCountry() {
      this.showSelect = !this.showSelect;
      if (this.showSelect) {
        this.$refs["select_country_icon"].style.transform = "rotate(180deg)";
      } else {
        this.$refs["select_country_icon"].style.transform = "rotate(0deg)";
      }
    },
    changeCountry(item) {
      this.form.countryCode = item.dialCode;
      this.countryIcon = item.iso2;
      this.showSelect = false;
      if (this.showSelect) {
        this.$refs["select_country_icon"].style.transform = "rotate(180deg)";
      } else {
        this.$refs["select_country_icon"].style.transform = "rotate(0deg)";
      }
    },
    goAD() {
      window.open(
        `https://platform.antdiy.vip/#/login?mailbox=${this.form.email}`
      );
      this.isSuccessful = false;
    },
    locationAD() {
      window.location = `https://platform.antdiy.vip/#/login?mailbox=${this.form.email}`;
      this.isSuccessful = false;
    },
    count() {
      let siv = setInterval(() => {
        this.waittime--;
        if (this.waittime <= -1) {
          clearInterval(siv);
          this.waittime = 59;
          this.showCode = true;
        }
      }, 1000);
      this.timer = siv;
    },
    write(index) {
      if (index == 1) {
        this.error1 = false;
        this.errorEmail = "";
      } else if (index == 2) {
        this.error2 = false;
        this.errorCode = "";
      } else if (index == 3) {
        this.error3 = false;
      } else if (index == 4) {
        this.error4 = false;
      }
    },
    count2() {
      let siv2 = setInterval(() => {
        this.skipTime--;
        if (this.skipTime <= -1) {
          clearInterval(siv2);
          this.skipTime = 5;
          this.locationAD();
        }
      }, 1000);
    },
  },
  created() {},
};
</script>
<style scoped>
.pallet_station {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f6f7fa;
  font-family: Helvetica;
}
.pallet_station_head {
  width: 100%;
  background: #ffffff;
}
.pallet_station_head div {
  width: 100%;
  max-width: 1108px;
  margin: auto;
}
.pallet_station_head img {
  width: 155px;
  margin: 16px 0;
}
.pallet_station_content {
  width: 100%;
  max-width: 1108px;
  display: flex;
  gap: 32px;
  padding: 28px;
  background: #ffffff;
  box-shadow: 2px 4px 4px 0px rgba(0, 0, 0, 0.08);
  border-radius: 16px;
  margin: 28px 0 60px 0;
}
.pallet_station_content_left {
  width: 492px;
  height: 738px;
  position: relative;
  border-radius: 8px;
}
.pallet_station_content_right {
  flex: 1;
}
.pallet_station_content_left .logo {
  width: 100%;
  border-radius: 8px;
}
.left_intro {
  background-image: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 2, 14, 0.8) 100%
  );
  backdrop-filter: blur(10px);
  padding: 16px 28px 28px;
  border-radius: 0 0 8px 8px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: absolute;
  bottom: 0;
}
.left_intro .left_intro_li {
  display: flex;
  align-items: center;
}
.left_intro_li img {
  width: 52px;
  height: 52px;
  margin-right: 16px;
}
.left_intro_li span {
  font-size: 18px;
  color: #ffffff;
  line-height: 26px;
  font-weight: 400;
}
.pallet_station_content_right .right_info {
  font-size: 24px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 36px;
  font-weight: 400;
  margin-top: 28px;
  margin-bottom: 28px;
}
.right_form {
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.right_form .cs_form_inp {
  width: 100%;
  display: flex;
}
.right_form .right_form_li {
  width: 100%;
  display: flex;
  position: relative;
}
.right_form .right_form_li .get_code {
  min-width: 123px;
  height: 56px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.45);
  border-radius: 8px;
  font-size: 16px;
  color: #fb5421;
  text-align: center;
  line-height: 56px;
  font-weight: 400;
  margin-left: 12px;
  cursor: pointer;
}
.select_country {
  width: 105px;
  min-width: 105px;
  height: 56px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.45);
  border-right: none;
  border-radius: 8px 0px 0px 8px;
  padding: 15px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.select_country .country_code {
  display: flex;
  align-items: center;
}
.select_country .country_code span {
  margin-left: 4px;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 24px;
  font-weight: 400;
}
.country_list {
  position: absolute;
  top: 60px;
  left: 0;
  width: 100%;
  height: 268px;
  background: #ffffff;
  box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08);
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  padding: 10px 4px;
  overflow-y: auto;
  z-index: 1;
}
.country_list_li {
  display: flex;
  align-items: center;
  padding: 6px 8px;
  cursor: pointer;
}
.country_list_li:hover {
  background: #f5f5f5;
  border-radius: 4px;
}
.country_list_li .dial_code {
  margin-left: 9px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.88);
  font-weight: 400;
}
.get_code_disabled {
  cursor: not-allowed !important;
  color: rgba(0, 0, 0, 0.85) !important;
}
.right_describe {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.65);
  line-height: 24px;
  font-weight: 400;
  margin: 16px 0 28px 0;
}
.right_button {
  width: 100%;
  background: #fb5421;
  border-radius: 28px;
  height: 56px;
  font-family: Helvetica-Bold;
  font-size: 20px;
  line-height: 56px;
  color: #ffffff;
  text-align: center;
  font-weight: 700;
  cursor: pointer;
}
.right_button:active {
  background: #e34a1e;
}
.go_ad {
  color: rgba(0, 0, 0, 0.65);
  font-size: 16px;
  margin-top: 16px;
  cursor: pointer;
  text-decoration: underline;
}

.right_form input,
.right_form select {
  flex: 1;
  height: 56px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.45);
  border-radius: 8px;
  padding: 0 12px;
  font-size: 16px;
  letter-spacing: 0;
  text-align: justify;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
}
.right_form input:focus {
  border: 2px solid rgba(251, 84, 33, 1);
}
.right_form_li_country input {
  border-radius: 0px 8px 8px 0px;
}
.password_inp {
  position: relative;
  display: flex;
  align-items: center;
}
.password_inp img {
  position: absolute;
  right: 16px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.password_inp input {
  padding-right: 36px;
}
.country_search {
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}
.country_search img {
  position: absolute;
  right: 8px;
  width: 20px;
  height: 20px;
}
.country_search input {
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  width: 100%;
  height: 32px;
  font-size: 14px;
}
.right_form input::-webkit-input-placeholder {
  color: rgba(0, 0, 0, 0.25);
}
.right_form input:-moz-placeholder {
  color: rgba(0, 0, 0, 0.25);
}
.right_form input:-ms-input-placeholder {
  color: rgba(0, 0, 0, 0.25);
}
.cs_form_inp_error input {
  border: 2px solid rgba(255, 39, 39, 1);
  border-radius: 8px;
}
.right_form_li_country .cs_form_inp_error input {
  border-radius: 0px 8px 8px 0px;
}
.pallet_station_foot {
  width: 100%;
  max-width: 1108px;
}
.pallet_station_foot .foot_title {
  font-family: Helvetica-Bold;
  font-size: 24px;
  color: rgba(0, 0, 0, 0.85);
  text-align: center;
  font-weight: 700;
  margin-bottom: 32px;
}
.pallet_station_foot .foot_list {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding-bottom: 20px;
}
.pallet_station_foot .foot_list .foot_list_li {
  background: #ffffff;
  border-radius: 8px;
  flex: 1;
  width: 18%;
}
.pallet_station_rights {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.45);
  font-weight: 400;
  margin: 52px 0 48px 0;
}
.country_dialog {
  position: fixed;
  width: 100%;
  height: 100%;
}
.successful_dialog {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.45);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.successful_dialog_box {
  width: 560px;
  padding: 45px 24px;
  background: #ffffff;
  box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08);
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.successful_dialog_box img {
  width: 70px;
  height: 70px;
  margin-bottom: 29px;
}
.dialog_content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.dialog_content .dialog_title {
  font-family: Helvetica-Bold;
  font-size: 24px;
  color: rgba(0, 0, 0, 0.85);
  text-align: center;
  line-height: 32px;
  font-weight: 700;
}
.dialog_content .dialog_span {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.45);
  text-align: center;
  line-height: 22px;
  font-weight: 400;
  margin: 8px 0 24px 0;
}
.dialog_button {
  width: 288px;
  height: 56px;
  background: #fb5421;
  border-radius: 28px;
  font-family: Helvetica-Bold;
  font-size: 20px;
  color: #ffffff;
  text-align: center;
  line-height: 56px;
  font-weight: 700;
  margin-bottom: 8px;
  cursor: pointer;
}
.dialog_foot {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
  text-align: center;
  line-height: 22px;
  font-weight: 400;
}
.dialog_foot span {
  font-weight: 700;
}
.error_code {
  font-size: 14px;
  color: #ff4d4f;
  margin-top: 3px;
}

.mo_right_info,
.mo_left_intro,
.dialog_foot_box,
.mo_br {
  display: none;
}
@media (max-width: 767px) {
  .successful_dialog_box {
    position: absolute;
    height: 70%;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 6px 16px -8px rgba(0, 0, 0, 0.08);
    box-shadow: 0px 9px 28px 0px rgba(0, 0, 0, 0.05);
    box-shadow: 0px 12px 48px 16px rgba(0, 0, 0, 0.03);
    border-radius: 12px 12px 0px 0px;
    justify-content: space-between;
    padding: 19px 16px 16px;
  }
  .dialog_content img {
    margin-top: 59px;
    margin-bottom: 37px;
  }
  .dialog_content .dialog_span {
    margin-top: 16px;
  }
  .dialog_content .dialog_button,
  .dialog_content .dialog_foot {
    display: none;
  }
  .dialog_foot_box {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .mo_br {
    display: block;
  }
  .dialog_button {
    width: 100%;
    font-size: 16px;
    height: 48px;
    line-height: 48px;
    margin: 8px 0 0;
  }
  .pallet_station {
    padding: 0 12px;
  }
  .pallet_station_head {
    position: fixed;
    top: 0;
    left: 0;
  }
  .pallet_station_head > div {
    display: flex;
    justify-content: center;
  }
  .pallet_station_head img {
    width: 104px;
    margin: 10px 0;
  }
  .pallet_station_foot .foot_list {
    gap: 7px;
  }
  .pallet_station_foot .foot_list .foot_list_li {
    min-width: 45%;
    display: flex;
    justify-content: center;
    background: #fcfcfd;
    border-radius: 4px;
  }
  .pallet_station_foot .foot_list .foot_list_li img {
    width: 100%;
    max-width: 200px;
  }
  .pallet_station_content {
    padding: 16px;
    margin: 16px 0 48px 0;
  }
  .pallet_station_content_left,
  .right_info {
    display: none;
  }
  .mo_right_info {
    display: block;
    margin-top: 77px;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 24px;
    font-weight: 400;
    text-align: center;
  }
  .mo_left_intro {
    display: flex;
    position: inherit;
    gap: 12px;
    margin: 28px 0 4px 0;
    background: none;
    padding: 0;
  }
  .mo_left_intro .left_intro_li span {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
    line-height: 20px;
    font-weight: 400;
  }
  .mo_left_intro .left_intro_li img {
    width: 40px;
    height: 40px;
    margin-right: 12px;
  }
  .right_form {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .right_form input,
  .right_form select {
    height: 48px;
  }
  .right_form .right_form_li .get_code {
    min-width: 93px;
    width: 93px;
    height: 48px;
    line-height: 48px;
  }
  .right_form .right_form_li .select_country {
    height: 48px;
  }
  .right_button {
    font-size: 16px;
    height: 48px;
    line-height: 48px;
  }
  .pallet_station_foot .foot_title {
    font-size: 20px;
  }
  .pallet_station_rights {
    font-size: 14px;
    margin: 48px 0 28px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/VXPublicAcount/tiktoksupply.vue